/**
 * up/down mixin
 */

/**
 * upDownMixinFactory
 * returns upDownMixin mixin factory
 *
 * @class upDownMixinFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.upDownMixin} mixin factory
 *
 * @ngdoc factory
 * @name mwApp.factory:upDownMixinFactory
 */
/* @ngInject */
export default function upDownMixinFactory ($http, alertLiteSvc) {
  var up = '"UP"'
  var down = '"DOWN"'

  /**
   * Mixin for moving Entities up and down among array
   *
   * @mixin upDownMixin
   * @memberof models
   * @see models
   * @param  {String} field - sort field
   * @return {Object}
   */
  function upDownMixin (field) {
    /**
     * Move entity among array of siblings
     * (swap sort field with neighbour below or above)
     *
     * @private
     * @memberof models.upDownMixin
     * @param {*} array
     * @param {Boolean} direction - true -> up, false -> down
     */
    function moveEntityAmong (element, array, direction) {
      // if there is no array, or array length == 0 or 1 -> there is nothing to do, nowhere to move
      if (!array || array.length <= 1) {
        return
      }

      // copy and sort array
      var arr = array.slice()
      arr.sort(function (a, b) {
        var oa = a[field]
        var ob = b[field]
        return (direction ? 1 : -1) * (oa > ob ? 1 : (oa < ob ? -1 : 0))
      })

      // find previous element in array and swap [field]s of entity and this previous entity
      var fieldValue = element[field]
      var prev, i

      // if element is first in array -> there is nothing to do, nowhere to move entity
      if (element !== arr[0]) {
        // so we skip first element
        for (i = 1; i < arr.length; i++) {
          prev = arr[i - 1]
          if (element === arr[i]) {
            element[field] = prev[field]
            prev[field] = fieldValue
            return
          }
        }
      }
    }

    return {

      /**
       * Move Entity up, perform PATCH request to server
       *
       * @memberof models.upDownMixin#
       * @param {*} among - array with entities
       * @return {Promise} promise
       */
      _up: function (among) {
        return $http.patch(this._url, up)
          .then(
            () => {
              if (field && among && among.length) {
                moveEntityAmong(this, among, true)
              }
            }
          )
          .catch(alertLiteSvc.alertError)
      },

      /**
       * Move Entity down, perform PATCH request to server
       *
       * @memberof models.upDownMixin#
       * @param {*} among - array with entities
       * @return {Promise} promise
       */
      _down: function (among) {
        return $http.patch(this._url, down)
          .then(
            () => {
              if (field && among && among.length) {
                moveEntityAmong(this, among, false)
              }
            }
          )
          .catch(alertLiteSvc.alertError)
      }

    }
  }

  return upDownMixin
}
